import apiClient from './apiClient';

const normalizeAsset = (asset) => ({
  ...asset,
  type: String(asset?.type || '').toUpperCase(),
  criticality: String(asset?.criticality || 'MEDIUM').toLowerCase(),
  status: String(asset?.status || 'ACTIVE').toLowerCase()
});

const toApiPayload = (payload) => ({
  ...payload,
  ...(payload.type != null && { type: String(payload.type).toUpperCase() }),
  ...(payload.criticality != null && { criticality: String(payload.criticality).toUpperCase() }),
  ...(payload.status != null && { status: String(payload.status).toUpperCase() })
});

export async function fetchAssets() {
  const { data } = await apiClient.get('/assets');
  return data.map(normalizeAsset);
}

export async function addAsset(payload) {
  const { data } = await apiClient.post('/assets', toApiPayload(payload));
  return normalizeAsset(data);
}

export async function updateAsset(id, payload) {
  const { data } = await apiClient.patch(`/assets/${id}`, toApiPayload(payload));
  return normalizeAsset(data);
}

export async function deleteAsset(id) {
  await apiClient.delete(`/assets/${id}`);
  return id;
}
